<template>
	<div class="productChild">
		<el-row>
			<el-col :span="24">
				<div class="productList">
					<ul>
						<li v-for="(item,index) in productList.slice(0,showL)" @click="goDetails(item.id)">
							<div class="productPic">
								<img :src="settings.apiBaseImg+item.image" alt="product" />
							</div>
							<div class="productIntro">
								<p class="productTitle">{{item.name}}</p>
								<p class="productModel">型号：{{item.xinghao}}</p>
								<p class="productPress">压力：{{item.pressure}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp流量：{{item.flow}}</p>
							</div>
						</li>
					</ul>
				</div>
				<div class="more">
					<el-pagination background layout="prev, pager, next" :total="total" @size-change="handleSizeChange"
					 @current-change="handleCurrentChange" :page-size="pageSize"></el-pagination>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import request from "../../assets/js/request.js";
	import qs from "qs";
	export default {
		data() {
			return {
				activeIndex: 0,
				showL: 16,
				productList: [],
				id: 0,
				name: "",
				names: "",
				currentPage: 1,
				pageSize: 12,
				total: 0,
			};
		},
		watch: {
			"$route.query": {
				handler(query) {
					let path = this.$route.path;
					this.id = this.$route.query.id;
					this.getKeyword();
				},
			},
		},
		created() {
			this.id = this.$route.query.id;
			this.getKeyword(this.currentPage, this.pageSize);
		},
		methods: {
			getKeyword(currentPage, pageSize) {
				if (this.$route.query.keyWord != undefined) {
					request
						.post(
							this.settings.apiBaseUrl + "/api/index/search_keyword",
							qs.stringify({
								keyword: this.$route.query.keyWord,
								pageNum: currentPage,
								pageSize: pageSize,
							}), {
								headers: {},
							}
						)
						.then((res) => {
							if (res.code == 1) {
								console.log("asdfasdfasdfasdfsdf", res);
								this.productList = res.data;

								this.total = res.data.total;
							} else {
								this.$message.error(res.msg);
							}
						});
				} else {
					this.getData(this.id, "", "", "", this.currentPage, this.pageSize);
				}
			},
			getStyle(index) {
				this.activeIndex = index;
			},
			goMore() {
				if (this.showL < this.productList.length) {
					this.showL = this.showL + 4;
				} else {
					this.$message("暂无更多设备信息");
				}
			},
			getData(id, idTwo, name, names, currentPage, pageSize) {
				this.name = name;
				this.names = names;
				request
					.post(
						this.settings.apiBaseUrl + "/api/index/products_list",
						qs.stringify({
							product_type_pid: id,
							product_type_id: idTwo,
							page: currentPage,
							pagesize: pageSize,
						}), {
							headers: {},
						}
					)
					.then((res) => {
						if (res.code == 1) {
							this.productList = res.data.rows;
							this.total = res.data.total;
						} else {
							this.$message.error(res.msg);
						}
					});
			},
			goDetails(id) {
				const {
					href
				} = this.$router.resolve({
					path: '/productDetails',
					query: {
						id: id,
						name: this.name,
						names: this.names
					}
				});
				window.open(href, "_blank");
			},
			//分页事件
			handleSizeChange(val) {
				this.pageSize = val; //将每页显示的条数 = 改变的值
				this.getData(this.id, "", "", "", this.currentPage, this.pageSize);
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getData(this.id, "", "", "", this.currentPage, this.pageSize);
			},
		},
	};
</script>

<style scoped="scoped">
	.productChild {
		width: 100%;
		height: auto;
		clear: both;
		padding-bottom: 100px;
	}

	.product /deep/ .el-row {
		width: 100%;
		height: auto;
	}

	.product .Title {
		height: 29px;
		font-size: 30px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #1a1a1a;
		line-height: 18px;
	}

	.product .productType {
		width: 100%;
		height: 60px;
	}

	.product .productE {
		width: 15%;
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #1a1a1a;
		opacity: 0.5;
		display: inline-block;
		line-height: 60px;
	}

	.product /deep/ .el-breadcrumb__item {
		cursor: pointer;
	}

	.product /deep/ .el-breadcrumb__item:hover {
		color: #216bd1;
	}

	.productList {
		width: 100%;
		height: auto;
		margin-top: 80px;
		clear: both;
		overflow: hidden;
	}

	.productList ul li:nth-child(1n) {
		margin-left: 10px;
	}

	.productList ul li {
		width: 23%;
		height: 404px;
		float: left;
		margin-right: 20px;
		transition: all 0.5s ease;
		cursor: pointer;
		margin-bottom: 50px;
	}

	.productList ul li:nth-child(4n) {
		margin-right: 0;
	}

	.productPic {
		width: 100%;
		height: 70%;
		clear: both;
		position: relative;
		margin: auto;
		overflow: hidden;
	}

	.productPic img {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		margin-bottom: 20px;
		max-width: 100%;
		margin: auto;
	}

	.productIntro {
		width: 100%;
		height: 30%;
		padding-left: 10px;
		transition: all 0.5s ease;
	}

	.productIntro .productTitle {
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #252525;
		line-height: 29px;
		padding: 20px 0 15px 0;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.productIntro .productModel,
	.productPress {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #7f7f7f;
		line-height: 21px;
	}

	.productModel {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.productList ul li:hover {
		background-color: #ffffff;
		box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
	}

	.productList ul li:hover .productIntro {
		background-color: #216bd1;
	}

	.productList ul li:hover .productTitle {
		color: #ffffff;
	}

	.productList ul li:hover .productModel {
		color: #ffffff;
	}

	.productList ul li:hover .productPress {
		color: #ffffff;
	}

	.more {
		width: 100%;
		height: auto;
		text-align: center;
	}

	@media screen and (max-width: 750px) {
		.productList ul li {
			width: 90%;
			height: 404px;
			float: left;
			margin-right: 20px;
			transition: all 0.5s ease;
			cursor: pointer;
			margin-bottom: 50px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/product/product.vue